import { render, staticRenderFns } from "./titlesPage.vue?vue&type=template&id=0b58fb2c&"
import script from "./titlesPage.vue?vue&type=script&lang=js&"
export * from "./titlesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports